import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    searchParams: '',
    userInfo: {
      id: '',
      userName: '',
      token: '',
      cash: '',
      cashOut: '',
      cardName: '',
      inviteUrl: '',
      registerTime: '',
      taxCash: '',
      taxType: '',
      payInTotal: 0,
      spinLimit: 0,
      spinTotal: 0
    },
    payInCashList: [],
  },
  getters: {},
  mutations: {
    SETPAYINCASHLIST (state, data) {
      state.payInCashList = data;
    },
    SETUSERINFO (state, data) {
      state.userInfo = data;
    },
    SETCASH (state, data) {
      state.userInfo.cash = data.cash;
      state.userInfo.cashOut = data.cashOut;
      state.userInfo.payInTotal = data.payInTotal;
    },
    SETSPININFO (state, data) {
      state.userInfo.spinLimit = data.spinLimit;
      state.userInfo.spinTotal = data.spinTotal;
    },
    SETTAXCASH (state, data) {
      state.userInfo.taxCash = data.taxCash;
      state.userInfo.taxType = data.taxType;
    },
    SETSEARCHPARAMS (state, data) {
      state.searchParams = data;
    },
    LOGOUT (state) {
      state.userInfo = {
        id: '',
        userName: '',
        token: '',
        cash: '',
        cashOut: '',
        inviteUrl: '',
        payInTotal: ''
      }
    }
  },
  actions: {},
  modules: {},
  plugins: [createPersistedState()]
})
